import React from 'react';
import { map } from 'lodash';
import common from '../../../common/common';
import translateService from '../../../common/translateService';
import {
  getQtyAvailable,
  isAvailable,
  isBooking,
  isBookingOverstock,
  isPreorder,
  isSoonAvailable,
} from '../../../services/product/productService';
import {
  showOverlay,
  hideOverlay,
} from '../../../services/product/productInteraction';

const ProductOptionsColor = (props) => {
  const handleMouseEnter = (e) => {
    showOverlay(e, props.isMobile);
  };

  const handleMouseLeave = (e) => {
    hideOverlay(e, props.isMobile);
  };

  const handleClick = (e) => {
    props.updateSelection(e, true);
  };

  const colorGallery = map(props.values, (v, i) => {
    const qtyAvailable = getQtyAvailable(
      props.isKit,
      props.selection,
      props.options,
      props.attrName,
      v.value,
    );
    const booking =
      isBooking(
        v.value,
        props.attrName,
        props.options,
        props.selection,
        props.isKit,
      ) ||
      isBookingOverstock(
        props.options,
        props.attrName,
        v.value,
        props.selection,
        props.isKit,
      );
    const soonAvailable = isSoonAvailable(
      v.value,
      props.attrName,
      props.options,
      props.selection,
      props.isKit,
    );
    const preorder = isPreorder(
      v.value,
      props.attrName,
      props.options,
      props.selection,
      props.isKit,
    );

    const availableOrBooking =
      isAvailable(
        props.isKit,
        props.selection,
        props.options,
        props.attrName,
        v.value,
        props.qtySelected,
      ) ||
      booking ||
      preorder;

    return (
      <button
        type='button'
        className='prd-option-color'
        data-value={v.value}
        data-attr={props.attrName}
        data-image={v.imageBrowse}
        key={i}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleClick}
      >
        <img
          className={`${availableOrBooking ? '' : 'unavailable'} ${
            v.value === props.selection[props.attrName] ? 'selected' : ''
          }`.trim()}
          src={common.contentFromCdn({
            path: v.imageBrowse,
            keepUrlAsIs: false,
          })}
          alt={`${props.attrName}: ${v.value}`}
        />
        <div
          className={
            v.value === props.selection[props.attrName] ? 'overlay' : ''
          }
        />
        {availableOrBooking && (
          <span
            className={`prd-option-color-marker ${
              qtyAvailable >= props.qtySelected || soonAvailable || preorder
                ? 'green'
                : 'blue'
            }`}
          />
        )}
        {availableOrBooking && v.value === props.selection[props.attrName] && (
          <p
            className={`prd-option-color-label ${
              qtyAvailable >= props.qtySelected || soonAvailable || preorder
                ? 'green'
                : 'blue'
            }`}
          >
            {qtyAvailable >= props.qtySelected
              ? translateService.get(`productDetail.availability.available`)
              : preorder
              ? translateService.get(`productDetail.availability.preorder`)
              : translateService.get(`productDetail.availability.booking`)}
          </p>
        )}
      </button>
    );
  });

  return (
    <div className='prd-option prd-options-color'>
      <h2>
        <span className='prd-options-name'>{props.name}:</span>{' '}
        <span>{props.selection[props.attrName]}</span>
      </h2>
      <div className='prd-options-color-gallery'>{colorGallery}</div>
    </div>
  );
};

export default ProductOptionsColor;
